export default __webpack_public_path__ + "static/media/nvidia-.85dc2d11.svg";